import Meta from './meta'

export default function Layout({ preview, children }) {
    return (
        <>
            <Meta />
            <div className="min-h-screen mt-12 lg:mt-0">
                <main>{children}</main>
            </div>
        </>
    )
}
